export class CurrentWeatherModel {
  location: string;
  weatherDescriptions: string;
  temperature: number;
  icon: string;
  windSpeed: string;
  humidity: string;
}
